import React, { useEffect, useRef, useState } from 'react';
import { Card, Row, Col, Button, Space, Popconfirm, Tooltip } from 'antd';
import MUIDatagrid, { IMUIDataGridColumns } from '../../../AltisComponent/MUIDataGrid';
import { useTranslation } from 'react-i18next';
import { StateLoader } from '../../../redux/StateLoader';
import { IAuthentication, UserRole } from '../../../interfaces/authentication';
import HTTPService from '../../../utils/makerequest';
import i18n from '../../../i18n';
import { DeleteOutlined, EditOutlined, ToolOutlined } from "@ant-design/icons";
import { Toast } from 'primereact/toast';

const ActivityName: React.FunctionComponent<any> = () => {
  const { t } = useTranslation();
  const dataGridRef = useRef<any>(null);
  const loader = new StateLoader();
  const userInfo: IAuthentication = loader.loadAuthState();
  const [activityData, setActivityData] = useState({ data: [], count: 0 });
  const toast = useRef<any>(null);

  useEffect(() => {
    ActivityFilter();
  }, [i18n.language]);

  const DeleteActivity = (Id) => {
    HTTPService.DELETE(`/Activity/deleteActivity?Id=${Id}`).then(
      (response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t(response.data),
            life: 3000
          });
          dataGridRef.current.GetAllData()
        } else if (response.status === 400) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
        else if (response.status === 450) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
      }
    );
  };

  const maintenanceType = {
    [t('Periodic Maintenance')]: 1,
    [t('Fault Maintenance')]: 2,
  }

  const isAltisAdmin = userInfo?.role === UserRole.AltisAdmin;

  const columns: IMUIDataGridColumns[] = [
    ...(userInfo.role == UserRole.AltisAdmin ? [{
      title: t('Company Name'),
      key: 'companyName',
      isSorting: true,
      placeHolder: t('Company Name'),
    }] : []),
    {
      title: t('activity_name'),
      key: 'activityName',
      placeHolder: t('activity_name'),
      isSorting: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      title: t('careType'),
      key: 'maintenanceType',
      placeHolder: t('careType'),
      headerAlign: 'center',
      align: 'center',
      enumValues: maintenanceType,
      render: (value) => {
        return <div style={{ textAlign: 'center' }}>{t(value)}</div>;
      }
    },
    {
      title: t('operations'),
      key: 'operations',
      placeHolder: t('operations'),
      align: 'center',
      headerAlign: 'center',
      hideColumnMenu: true,
      render: (order, record) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10, marginLeft: isAltisAdmin ? 160 : 10 }}>
            <Space size={10}>
              <Popconfirm
                title={<div>{t('are_you_sure_activity')} <br /></div>}
                onConfirm={() => DeleteActivity(record.activityId)}
                okText={t('yes')}
                cancelText={t('no')}
              >
                <Tooltip title={t('delete')}>
                  <Button
                    size='small'
                    icon={<DeleteOutlined />}
                    onClick={(e) => { e.stopPropagation(); }}
                    style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
                  />
                </Tooltip>
              </Popconfirm>
              <Tooltip title={t('update')}>
                <Button
                  size='small'
                  icon={<EditOutlined />}
                  onClick={() => window.location.replace('/admin/update-activity-name/' + record.activityId)}
                  style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
                />
              </Tooltip>
            </Space>
          </div>
        );
      }
    }
  ];


  const ActivityFilter = (e?) => {
    const filters = e?.filters;

    if (filters?.maintenanceType !== undefined) {
      if (filters.maintenanceType === "" || filters.maintenanceType === null) {
        delete filters.maintenanceType;
      } else {
        filters.maintenanceType = [Number(filters.maintenanceType)];
      }
    }

    const body = {
      sortColumn: e?.sortField,
      sortOrder: e?.sortOrder || 'asc',
      pageSize: e?.pageSize || 50,
      page: e?.page || 1,
      ...filters,
    };


    HTTPService.POST(`/Activity/filters`, body).then((response) => {
      if (!response.data) return;
      if (response.status === 200) {
        setActivityData(response.data);
      } else if (response.status === 450) {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      }
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="row">
        <div className="col-md-4 mb-3">
          <Button
            type="primary"
            shape="round"
            style={{
              height: 64,
              width: 'auto',
              backgroundColor: 'transparent',
              color: '#1890ff',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '5px',
              padding: 0,
              border: 'none',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              display: userInfo.role === UserRole.Sayman ? 'none' : 'flex',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
              e.currentTarget.style.color = '#40a9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.color = '#1890ff';
            }}
            size="middle"
            onClick={() => window.location.replace('admin/add-activity-name')}
          >
            <ToolOutlined style={{ fontSize: 24 }} />
            <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
              {t('add_activity')}
            </span>
          </Button>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="table-container">
            <MUIDatagrid ref={dataGridRef} data={activityData?.data} total={activityData?.count} columns={columns} filterMode='server' onChange={ActivityFilter} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivityName;
